import {Routes} from '@angular/router';
import {AuthGuard} from '@core/services/auth-guard.service';
import {TaxFormsIframeContentComponent} from "./components/tax-forms-iframe-content/tax-forms-iframe-content.component";
import { PlatformLinkCreatorComponent } from '@shared/components/platform-tool/platform-link-creator/platform-link-creator.component';

export const TaxFormsRoutes: Routes = [
  {
    path     : 'itrce-planner/forms',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path     : 'itrce-planner/formsV2',
    component: TaxFormsIframeContentComponent,
    canActivate: [AuthGuard]
  }
];
